import { SUBSCRIBE_DEVICE_REQUEST, SUBSCRIBE_DEVICE_SUCCESS, SUBSCRIBE_DEVICE_FAILURE, UNSUBSCRIBE_DEVICE_ACTION } from "./actions";

export interface SubscribeDeviceState {
  isSubscribed: boolean;
}

const initialState: SubscribeDeviceState = {
  isSubscribed: false,
};

export default function subscribeDeviceReducer(state = initialState, action: any) {
  switch (action.type) {
    case SUBSCRIBE_DEVICE_REQUEST:
      console.log('SUBSCRIBE_DEVICE_REQUEST');
      return { ...state, isSubscribed: true };
    case SUBSCRIBE_DEVICE_SUCCESS:
      console.log('SUBSCRIBE_DEVICE_SUCCESS');
      console.log('subscribeDeviceSuccessAction', action.payload);
      return { ...state, isSubscribed: true };
    case SUBSCRIBE_DEVICE_FAILURE:
      console.log('SUBSCRIBE_DEVICE_FAILURE');
      return { ...state, isSubscribed: false };
    case UNSUBSCRIBE_DEVICE_ACTION:
      console.log('UNSUBSCRIBE_DEVICE_ACTION');
      return { ...state, isSubscribed: false };
    default:
      return state;
  }
}   